import queryString from 'query-string';
import { getUserCurrentStore } from 'utils/auth';
import { settingsApi } from 'utils/api/baas/settings/axiosBase';

export async function getCashRegister(uuid: string) {
  const store = getUserCurrentStore()?.uuid;
  const response = await settingsApi.get(`/v1/cash-registers/${uuid}/`, {
    params: {
      store_uuid: store,
    },
    paramsSerializer: (p) => queryString.stringify(p, { arrayFormat: 'comma' }),
  });
  return response.data;
}

export async function updateCashRegister(uuid: string, data: { name: string }) {
  const store = getUserCurrentStore()?.uuid;
  const response = await settingsApi.put(`/v1/cash-registers/${uuid}/`, data, {
    params: {
      store_uuid: store,
    },
    paramsSerializer: (p) => queryString.stringify(p, { arrayFormat: 'comma' }),
  });
  return response.data;
}
